<template>
  <div>
    <b-alert :show="errors.any()" variant="danger" class="mb-2 py-2 px-4">
      <ul class="m-0 px-1">
        <li v-for="err in errors.all()" :key="err">{{err}}</li>
      </ul>
    </b-alert>

    <widget
      :type="widget.type"
      :title="widget.title"
      :subtitle="widget.subtitle"
      :url="widget.url"
      :availability="widget.availability"
      :viewData="widget.viewData"
      :view="widget.view"
      @update:type="widget.type = $event"
      @update:title="widget.title = $event"
      @update:subtitle="widget.subtitle = $event"
      @update:url="widget.url = $event"
      @update:availability="widget.availability = $event"
      @update:viewData="widget.viewData = $event"
      @update:view="widget.view = $event"
    >
      <b-input-group :prepend="$t('widgetAreas.count')">
        <numeric-input v-model="widget.count"/>
      </b-input-group>
    </widget>
  </div>
</template>

<script>
import EditorMixin from './EditorMixin'
import Widget from '../Widget'

export default {
  name: 'ProductGroupsWidget',
  mixins: [EditorMixin],
  components: {
    Widget
  }
}
</script>
